const highlights = [
  { id: 1, number: "01", label: "Fully funded learning" },
  { id: 2, number: "02", label: "African learner access" },
  { id: 3, number: "03", label: "Quarterly award structure" },
  { id: 4, number: "04", label: "Practical technology pathways" },
];

const ScholarshipSpotlightSection = () => {
  return (
    <section
      className="w-full text-white py-16 lg:py-[100px] px-6 lg:px-8"
      style={{
        backgroundColor: "#070951",
        backgroundImage:
          "radial-gradient(circle at 10% 20%, rgba(251,175,27,0.16), transparent 26%), linear-gradient(rgba(255,255,255,0.035) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.035) 1px, transparent 1px)",
        backgroundSize: "auto, 64px 64px, 64px 64px",
      }}
    >
      <div className="container mx-auto scholarship-grid-spotlight grid items-center gap-10 lg:gap-[90px]">
        <div>
          <p className="flex items-center gap-3 text-secondary font-poppins text-sm font-extrabold tracking-widest uppercase mb-5">
            <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
            Past Programme Spotlight
          </p>
          <h2
            className="text-white font-poppins font-bold tracking-[-0.045em] m-0"
            style={{ fontSize: "clamp(32px, 4vw, 55px)", lineHeight: 1.12 }}
          >
            The Ooni Tech Scholarship widened access to Utiva programmes.
          </h2>
          <p className="text-[#d8dfff] font-poppins text-[17px] leading-[1.8] mt-6 mb-0">
            Launched in 2021 to honour the Ooni of Ife, the initiative offered
            fully funded technology learning to selected African learners. It is
            presented here as a past programme, not a current open call.
          </p>
        </div>

        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3.5 m-0 p-0 list-none">
          {highlights.map((item) => (
            <li
              key={item.id}
              className="flex items-end gap-4 min-h-[112px] p-[23px] rounded-[18px] font-poppins text-[17px] font-bold"
              style={{
                background: "rgba(255,255,255,0.055)",
                border: "1px solid rgba(255,255,255,0.18)",
              }}
            >
              <span className="text-secondary font-poppins text-sm font-extrabold">
                {item.number}
              </span>
              {item.label}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default ScholarshipSpotlightSection;
